import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { withUser } from '../../utility/withUser';
import { connect } from 'react-redux';
import WaitForState from '../WaitForState';
import { createUser, getRoles, hasOneOfPermissions } from '../../utility/account';
import { addMessage } from '../../actions/messages';
import './index.css';

/**
 * Component for creating a user.
 *
 * @extends React.Component
 */
class CreateUserForm extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      passwordRepeat: "",
      name: "",
      email: "",
      phone: "",
      active: "1",
      roles: [],
      allRoles: null,
      doneWorking: true,
      createAllowed: [],
    }
  }

  /**
   * Handle when a field changes.
   */
  handleFieldChange = (field, e) => {
    var newState = {};
    newState[field] = e.target.value;
    this.setState(newState);
  }

  /**
   * Fetch whether or not user has permission to assign specific roles.
   */
  fetchCreateAllowedPermissions = () => {
    var roles = [
      'admin',
      'supervisor',
      'advisor',
    ];
    var permissionsToCheck = [];
    roles.forEach((role) => {
      permissionsToCheck.push('create ' + role + ' user');
    });
    permissionsToCheck.push('create any user');

    hasOneOfPermissions(this.props.user.id, permissionsToCheck, this.props.token, this.props.history, (oneAllowed, allowed, response) => {
      if (response.status === 200) {
        var createAllowed = [];
        roles.forEach((role) => {
          createAllowed[role] = allowed['create any user'];

          if (!createAllowed[role]) {
            createAllowed[role] = allowed['create ' + role + ' user'];
          }
        });

        this.setState({createAllowed: createAllowed});
      }
    });
  }

  /**
   * Handle when checkbox for a role changes.
   */
  handleRoleChange = (roleId, e) => {
    var selectedRole = this.state.allRoles[roleId].name;
    var newRoles = [];
    if (e.target.checked) {
      var found = false;
      newRoles = this.state.roles;
      newRoles.forEach((role) => {
        if (role === selectedRole) {
          found = true;
        }
      });

      if (!found) {
        newRoles.push(selectedRole);
      }
    } else {
      this.state.roles.forEach((role) => {
        if (role !== selectedRole) {
          newRoles.push(role);
        }
      });
    }

    this.setState({roles: newRoles});
  }

  /**
   * Get role as readable string
   */
  getReadableRole = (role) => {
    var roleMap = {
      admin: 'Administrator',
      supervisor: 'Vejleder',
      advisor: 'Frivillig',
    };

    if (roleMap[role]) {
      return roleMap[role];
    }

    return role;
  }

  /**
   * Fetch roles.
   */
  fetchRoles = () => {
    getRoles(this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af roller. Prøv venligst igen senere.', 'danger'));
        return;
      }

      response.json().then((data) => {
        var items = {};
        Object.values(data).forEach((item) => {
          items[item.id] = item;
        });
        this.setState({allRoles: items});
      });
    });
  }

  /**
   * Handle when the user clicks the create user button.
   */
  handleClickCreateUser = () => {
    this.setState({doneWorking: false});
    createUser({
      password: this.state.password,
      name: this.state.name,
      email: this.state.email,
      phone: this.state.phone,
      active: this.state.active,
      roles: this.state.roles,
    }, this.props.token, this.props.history, (response) => {
      this.setState({doneWorking: true});
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under oprettelse af bruger. Prøv venligst igen senere.', 'danger'));
        return;
      }

      this.props.dispatch(addMessage('Bruger oprettet.', 'success'));
      this.props.history.push('/settings/users');
    });
  }

  /**
   * Whether or not user is valid.
   */
  userIsValid = () => {
    if (this.state.email === "" ||
        this.state.password === "" ||
        this.state.name === "" ||
        this.state.roles.length === 0) {
      return false;
    }
    if (this.state.password !== this.state.passwordRepeat) {
      return false;
    }
    return true;
  }

  /** @inheritdoc */
  componentDidMount = () => {
    this.fetchRoles();
    this.fetchCreateAllowedPermissions();
  }

  /** @inheritdoc */
  render() {
    return (
      <div className="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile">
        <div className="widget">
          <WaitForState state={this.state} keys={['doneWorking']} />
          <h3 className="section-heading">Opret bruger</h3>
            <div>
              <div className="form-group">
                <label htmlFor="name">Navn</label>
                <input type="text" className="form-control" id="name" placeholder="Navn" value={this.state.name} onChange={(e) => {this.handleFieldChange('name', e);}} />
              </div>
              <div className="form-group">
                <label htmlFor="email">E-mail</label>
                <input type="email" className="form-control" id="email" placeholder="Email" value={this.state.email} onChange={(e) => {this.handleFieldChange('email', e);}}/>
              </div>
              <div className="form-group">
                <label htmlFor="password">Kodeord</label>
                <input type="password" className="form-control" id="password" placeholder="****" value={this.state.password} onChange={(e) => {this.handleFieldChange('password', e);}} />
              </div>
              <div className="form-group">
                <label htmlFor="password">Gentag kodeord</label>
                <input type="password" className="form-control" id="passwordRepeat" placeholder="****" value={this.state.passwordRepeat} onChange={(e) => {this.handleFieldChange('passwordRepeat', e);}} />
              </div>
              {this.state.password && this.state.password !== this.state.passwordRepeat && (
                <div className="form-group">
                  <span className="text-danger">Adgangskoderne er ikke ens.</span>
                </div>
              )}
              <div className="form-group">
                <label htmlFor="phone">Telefonnummer</label>
                <input type="text" className="form-control" id="phone" value={this.state.phone} placeholder="Telefonnummer" onChange={(e) => {this.handleFieldChange('phone', e);}} />
              </div>
              <WaitForState state={this.state} keys={['allRoles']}>
                {this.state.allRoles && (
                  <div className="form-group">
                    <label>Roller</label>
                    {Object.values(this.state.allRoles).map((role) => { return (
                      <div className="form-check" key={role.id}>
                        <input className="form-check-input" type="checkbox" value={role.id} id={"role-" + role.id} onChange={(e) => {this.handleRoleChange(role.id, e)}} disabled={this.state.createAllowed[role.name] ? '' : 'disabled'} />
                        <label className="form-check-label" htmlFor={"role-" + role.id}>
                          {this.getReadableRole(role.name)}
                        </label>
                      </div>
                    )})}
                  </div>
                )}
              </WaitForState>
              <div className="form-group">
                <label htmlFor="active">Active</label>
                <select className="form-control" id="active" value={this.state.active} onChange={(e) => {this.handleFieldChange('active', e);}}>
                  <option value={1}>Aktiveret</option>
                  <option value={0}>Deaktiveret</option>
                </select>
              </div>
              <div className="form-group">
                <input type="submit" disabled={!this.userIsValid() ? 'disabled' : ''} className="btn btn-primary" value="Opret bruger" onClick={this.handleClickCreateUser} />
              </div>
            </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(connect()(CreateUserForm)));



// WEBPACK FOOTER //
// ./src/components/CreateUserForm/index.js